export enum LeadQuestionnaireAnsweredEnum {
  ANSWERED = "ANSWERED",
  NOT_ANSWERED = "NOT_ANSWERED",
}
